import React, { useState, useEffect } from "react";
import { compact, cloneDeep, isEmpty } from "lodash";
import cx from "classnames";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useQueryParam } from "hooks/useQueryParam";
// eslint-disable-next-line no-restricted-imports
// eslint-disable-next-line no-restricted-imports
import { DoctorAccordion } from "../AppointmentSelectSlot/DoctorAccordion";
// eslint-disable-next-line no-restricted-imports
import { toTel } from "../utils/toTel";
// eslint-disable-next-line no-restricted-imports
import {
  getScheduleDays,
  getNextAvailableDate,
  updateQueryParam,
} from "../utils/calendarWeek";
import stylesV2 from "./MobileView.module.scss";
import stylesV3 from "./MobileViewV2.module.scss";
import { NearbyOffice } from "./NearbyOffice";
import { TrustBuildCard } from "./TrustBuildCard";
import { AppointmentExamDetails } from "./AppointmentExamDetails";
import { AppointmentSelectReturnStatus } from "./AppointmentSelectReturnStatus";
import { AppointmentAccountSetup } from "./AppointmentAccountSetup";
import { useTrackEvent } from "hooks/useTrackEvent";
import { Modal } from "components/Modal";
import circleCheck from "images/circle-check.svg";
import { API_DATE_FORMAT } from "api/constants";
import { Button, ButtonRole } from "components/Button";
import { InfoTooltip } from "components/InfoTooltip";
import { WaitlistV2 } from "features/scheduling/components/Waitlist/WaitlistV2";
import {
  DoctorAvailability,
  selectDoctorIdsOrderedByAvailability,
  selectNextAvailableDatesForOffice,
} from "features/scheduling/availabilitySummarySlice";
import {
  selectAppointmentData,
  selectIsEditForm,
  selectEditSection,
} from "features/appointmentDataSlice";
import * as paths from "features/routing/paths";
import { NavigationButton } from "features/scheduling/AppointmentSelectSlot/NavigationButton";
import { ConnectedDoctorSlots } from "features/scheduling/components/ConnectedDoctorSlots";
import { FeatureOffice } from "features/scheduling/components/FeatureOfficeBanner";
//import { DateInput, Hook } from "components/DateInput";
import { Doctor } from "types/doctor";
import { ExamType } from "types/examType";
import { Office } from "types/office";
import { PatientReturnStatus } from "types/patientReturnStatus";
import { MYEYEDR_WEBSITE_URL } from "utils/constants";
import { externalRedirect } from "utils/externalRedirect";
import { RootState } from "app/store";
import { selectNearbyOfficeLoadingState } from "features/scheduling/nearbyOfficesSlice";
import { updateSelectedAppointment } from "features/scheduling/appointmentCreationSlice";
import { Slot } from "types/slot";
import {
  selectUpcomingTimeslotsForOfficeByDate,
  selectIsLoaded,
  selectTimeslots,
} from "features/scheduling/timeSlotsSlice";
import successCircle from "images/success-circle-ticker.svg";
import errorCircle from "images/error-circle-cross.svg";
import { FirstAvailSlot } from "features/scheduling/FirstAvailSlot";
//import { useSchedulerTracking } from "hooks/useSchedulerTracking";
import arrowLeft from "images/vwo/arrow-left.svg";
import iconBaby from "images/vwo/icon-baby.svg";
import iconClip from "images/vwo/icon-clip.svg";
import iconSmile from "images/vwo/icon-smile.svg";
import iconReturn from "images/vwo/return.svg";
import vehPatientImg from "images/vwo/VEH-Patient.png";
import handbagIcon from "images/medical-handbag-blue.svg";
import { useSchedulingABVariant } from "../utils/useSchedulingABVariant";

// safely declare globals — access them only via helper functions
// to avoid ReferenceError crashes when the global is not yet defined on mount
declare let vehDisclaimerHide: string | undefined;
declare let orderContactUrl: string | undefined;

const getSafeVehDisclaimerHide = (): string =>
  typeof vehDisclaimerHide !== "undefined" ? vehDisclaimerHide : "";

const getSafeOrderContactUrl = (): string =>
  typeof orderContactUrl !== "undefined" ? orderContactUrl : "#";

const aria = {
  labelledby: "appointment-exam-details-modal-label",
  describedby: "appointment-exam-details-modal-description",
};

const ariaRestrict = {
  labelledby: "appointment-exam-RestrictVEH-details-modal-label",
  describedby: "appointment-exam-RestrictVEH-details-modal-description",
};

interface MobileViewProps {
  doctors: Doctor[];
  officeId: string;
  examType: ExamType;
  nearbyOffices: Office[];
  featureOffice: Office | null;
  showFeatureOffice: boolean;
  availabilitySlots: {
    [officeId: string]: {
      morning: number;
      afternoon: number;
      evening: number;
      total: number;
    };
  };
  patientReturnStatus: PatientReturnStatus;
  selectedOffice: Office;
  searchDate: string;
  setSearchDate: (newVal: string) => void;
  setTimeslotsExecution: () => void;
  setShowReview: (data: boolean) => void;
  setApptData: (data: any) => void;
  patientDetailsValid: any;
  newDateArr: any;
  newDesign: string | null;
  slotMetaData: any[];
  screenSize: number;
  editSectionModal: string | null;
  firstAvailDocs: any;
}
export const MobileView: React.FC<MobileViewProps> = ({
  doctors,
  officeId,
  examType,
  nearbyOffices,
  featureOffice,
  showFeatureOffice,
  availabilitySlots,
  patientReturnStatus,
  selectedOffice,
  searchDate,
  setSearchDate,
  setTimeslotsExecution,
  setShowReview,
  setApptData,
  patientDetailsValid,
  newDateArr,
  newDesign,
  slotMetaData,
  screenSize,
  editSectionModal,
  firstAvailDocs,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const history = useHistory();
  const dispatch = useDispatch();
  const { trackEvent } = useTrackEvent();
  const isMobileView = true;
  const examTypeRef = React.useRef<null | HTMLDivElement>(null);
  const patientTypeRef = React.useRef<null | HTMLDivElement>(null);
  const patientDetailsRef = React.useRef<null | HTMLDivElement>(null);
  const userSelectedDateRef = React.useRef<boolean>(false);
  const [firstAvail, setFirstAvail] = useQueryParam("firstAvail", false);
  const [vehpop] = useQueryParam("vehpop", "1");
  const [prevWeek, setPrevWeek] = React.useState<string>("");
  const [nextWeek, setNextWeek] = React.useState<string>("");
  const [selectedDate, setSelectedDate] = React.useState<undefined | string>(
    undefined
  );
  const { formattedPhone, officeUid } = selectedOffice;
  const [eyeExam, setEyeExam] = React.useState<undefined | ExamType>(undefined);
  const [selectedDoctor, setSelectedDoctor] = React.useState<
    undefined | Doctor
  >(undefined);
  const [selectedSlot, setSelectedSlot] = React.useState<undefined | Slot>(
    undefined
  );
  const [firstSlot, setFirstSlot] = React.useState<any>(null);
  const dummyPatientDetails = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    dateOfBirth: "",
    smsOptInNotices: true,
    smsOptInPromos: true,
  };
  const [patientDetails, setPatientDetails] =
    React.useState<any>(dummyPatientDetails);
  const [patientType, setPatientType] = React.useState<
    undefined | PatientReturnStatus
  >(undefined);
  const [nextButton, setNextButton] = React.useState(true);
  const [executeOnce, setExecuteOnce] = React.useState(false);
  const [dateFirstexecuteOnce, setDateFirstExecuteOnce] = React.useState(false);
  const [dataPush, setDataPush] = React.useState(false);
  const [showSlotSection, setShowSlotSection] = React.useState(false);
  const appoinmentData = useSelector(selectAppointmentData);
  const isEditForm = useSelector(selectIsEditForm);
  const editSection = useSelector(selectEditSection);
  const selectedDateTemp =
    selectedDate === undefined ? searchDate : selectedDate;
  const [vehSelectedSlot, setVehSelectedSlot] = React.useState<
    undefined | Slot
  >(undefined);
  const [vehDoctorTerms, setVehDoctorTerms] = React.useState<boolean>(false);
  const [restrictVehTerms, setRestrictVehTerms] =
    React.useState<boolean>(false);

  // Reset all local state when officeId changes (e.g. user picks a
  // nearby office). Without this, stale slot/doctor/patient state from the
  // previous office can cause render-time crashes or a blank white screen.
  React.useEffect(() => {
    userSelectedDateRef.current = false;
    setSelectedDoctor(undefined);
    setSelectedSlot(undefined);
    setVehSelectedSlot(undefined);
    setEyeExam(undefined);
    setPatientType(undefined);
    setPatientDetails(dummyPatientDetails);
    setShowSlotSection(false);
    setNextButton(true);
    setExecuteOnce(false);
    setDateFirstExecuteOnce(false);
    setDataPush(false);
    setFirstSlot(null);
    setSelectedDate(undefined);
    setVehDoctorTerms(false);
    setRestrictVehTerms(false);
  }, [officeId]);

  const doctorAvailbilities = useSelector(
    (state: RootState) =>
      selectNextAvailableDatesForOffice(
        state,
        officeId,
        selectedDateTemp,
        selectedOffice.timeSlotWeeks
      ),
    shallowEqual
  );
    //const { trackSchedulerEvent } = useSchedulerTracking();
  /*const onDateChange: Hook = (_selectedDates, dateStr) => {
    trackSchedulerEvent("browse-dates");
    setSearchDate(dateStr);
  };*/
  React.useEffect(() => {
    if(firstAvail &&
      firstAvail === "true" &&
      firstAvailDocs &&
      Object.keys(firstAvailDocs).length > 0) {
      const sort_first_Array = [];
      for (const doc in firstAvailDocs) {
        sort_first_Array.push(firstAvailDocs[doc]);
      }
      const sortFirstAvail = [...sort_first_Array].sort(
        (a, b) =>
          dayjs(a.date + " " + a.startTime).valueOf() -
          dayjs(b.date + " " + b.startTime).valueOf()
      );
      setFirstSlot(sortFirstAvail[0]);

    }
  }, [firstAvailDocs, firstAvail]);

  const isSlotLoaded = useSelector((state: RootState) => selectIsLoaded(state));

  const newDateRange = getScheduleDays();

  const doctorIds = [];
  for (let i = 0; i < doctors.length; i++) {
    doctorIds.push(doctors[i]["id"]);
  }

  let newSortedDoctor = [];
  let totalSlotCount = 0;
  newSortedDoctor = [...doctors].sort((a, b) => {
    const textA = a.lastName.toUpperCase();
    const textB = b.lastName.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
  let newSortedDoctorIds = newSortedDoctor.map((doctor) => doctor.id);
  const weekSlotCalendar: any[] = [];
  ["0", "1", "2", "3", "4", "5", "6"].map((i) =>
    weekSlotCalendar.push(
      dayjs(searchDate).add(parseInt(i), "day").format(API_DATE_FORMAT)
    )
  );
  if (isSlotLoaded) {
    if (screenSize <= 992 && !isEmpty(newDateArr) && !showSlotSection) {
      const doctorIds = [];
      for (let i = 0; i < doctors.length; i++) {
        doctorIds.push(doctors[i]["id"]);
      }
      const dateNotAvailArr = {};
      for (const key in newDateRange) {
        const doctorNotimeslot = {};
        let doctorNotimeslotArr = {};
        dateNotAvailArr[key] = {};
        if (typeof newDateArr[key] === "undefined") {
          for (let i = 0; i < doctorIds.length; i++) {
            const returnData = getNextAvailableDate(
              doctorIds[i],
              key,
              newDateArr,
              newDateRange
            );
            //console.log(doctorIds[i],key);
            //console.log(returnData);
            doctorNotimeslot[doctorIds[i]] = returnData; //getAvailableDate(doctorIds[i],key,newDateArr);
            doctorNotimeslotArr = { doctorID: doctorIds[i], count: returnData };
            //console.log(doctorNotimeslot[key]);
          }
        } else {
          for (let i = 0; i < doctorIds.length; i++) {
            //console.log(doctorIds[i],key);
            if (typeof newDateArr[key][doctorIds[i]] === "undefined") {
              const returnData = getNextAvailableDate(
                doctorIds[i],
                key,
                newDateArr,
                newDateRange
              );
               //console.log(returnData);
              doctorNotimeslot[doctorIds[i]] = returnData; //getAvailableDate(doctorIds[i],key,newDateArr);
              doctorNotimeslotArr = {
                doctorID: doctorIds[i],
                count: returnData,
              };
            }
          }
        }

        dateNotAvailArr[key] = doctorNotimeslot;
      }
       //console.log(dateNotAvailArr);
      const newDoctorAvailables = [];

      for (const availDoctor in newDateArr[selectedDateTemp]) {
        const foundDoctor = doctors.find(
          (doctor) => doctor.id === availDoctor
        );

        if (!foundDoctor) continue;
        const tempDoc = {
          ...foundDoctor,
          count: newDateArr[selectedDateTemp][availDoctor][0],
        };
        tempDoc.count = newDateArr[selectedDateTemp][availDoctor][0];
        totalSlotCount =
          totalSlotCount + newDateArr[selectedDateTemp][availDoctor][0];
        // FRemoved Object.preventExtensions() — it throws a TypeError in
        // strict mode if any Redux or a child component
        // attempts to add a property to the object after an office switch.
        newDoctorAvailables.push(tempDoc);
      }
      newDoctorAvailables.sort((a, b) => {
        if (a.count === b.count) {
          const textA = a.lastName.toUpperCase();
          const textB = b.lastName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return b.count - a.count;
        }
      });
      const newDoctorNextAvailables = [];
      const limitedDoctor = [];
      for (const availDoctor in dateNotAvailArr[selectedDateTemp]) {
        const nextAvailDoctor = dateNotAvailArr[selectedDateTemp][availDoctor];
        if (nextAvailDoctor[1] === "nextavailable") {
          const foundDoctor = doctors.find(
            (doctor) => doctor.id === availDoctor
          );

          if (!foundDoctor) continue;
          const slotCount = newDateArr[selectedDateTemp]?.[availDoctor]?.[0] ?? 0;

          const tempDoc = {
            ...foundDoctor,
            count: slotCount,
            date: nextAvailDoctor[2],
          };
          // Same removal of Object.preventExtensions()
          newDoctorNextAvailables.push(tempDoc);
        }
        if (nextAvailDoctor[1] == "") {
          limitedDoctor.push(availDoctor);
        }
      }
/*
    newDoctorNextAvailables.sort((a, b) => {
      if (a.date === b.date) {
        if (a.count === b.count) {
          const textA = a.lastName.toUpperCase();
          const textB = b.lastName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return b.count - a.count;
        }
      } else if (a.date !== b.date) {
        return new Date(a.date) - new Date(b.date);
      } else {
        return b.count - a.count;
      }
    }); */
      newDoctorNextAvailables.sort((a, b) => {
        const textA = a.lastName.toUpperCase();
        const textB = b.lastName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      const limitedDoctorList = [];
      for (const avail of limitedDoctor) {
        const doc = doctors.find((doctor) => doctor.id === avail);
        if (doc) limitedDoctorList.push(doc);
      }

      limitedDoctorList.sort(function (a, b) {
        const textA = a.lastName.toUpperCase();
        const textB = b.lastName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

      const avalDocids = newDoctorAvailables.map((item) => item.id);
      const avalNextDocids = newDoctorNextAvailables.map((item) => item.id);
      const limitedDocids = limitedDoctorList.map((item) => item.id);
      newSortedDoctorIds = [];
      newSortedDoctorIds = avalDocids.concat(avalNextDocids, limitedDocids);
    }
  }

  /*const avalDocids = newDoctorAvailables.map((item) => item.id);
  const avalNextDocids = newDoctorNextAvailables.map((item) => item.id);
  const limitedDocids = limitedDoctorList.map((item) => item.id);
  const newSortedDoctorIds = avalDocids.concat(avalNextDocids, limitedDocids);
  */
  const onSelectionTimeSlot = (type: string, value: Slot) => {
    let doctorCache: Doctor | undefined;
    doctors.map((doctor) => {
      if (value.doctorId === doctor.id) {
        doctorCache = doctor;
        setSelectedDoctor(doctor);
      }
    });

    // Read globals safely via helper to prevent ReferenceError
    // when the global hasn't been set yet after mounting for a new office.
    const hideQP =
      getSafeVehDisclaimerHide() === "true" || vehpop === "2" || vehpop === "true";

    if (doctorCache?.offersVEH &&
      !selectedOffice.hideVEHdisclaimer) {
      setVehDoctorTerms(true);
      setVehSelectedSlot(value);
    } else if (
      doctorCache?.offersVEH &&
      selectedOffice.hideVEHdisclaimer &&
      !hideQP
    ) {
      setVehDoctorTerms(true);
      setVehSelectedSlot(value);
    } else {
      setSelectedSlot(value);
      dispatch(
        updateSelectedAppointment({
          officeId,
          officeUid,
          ...value,
        })
      );
    }
    isFormValidation({
      eyeExam: eyeExam,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: value,
      patientDetails: patientDetails,
    });
    setDataPush(false);
    trackEvent("step-2-scheduler-start", {
      location: officeId,
      logicalId: selectedOffice.logicalId,
    });
    trackEvent("step-5-selected-appointment-time", {
      location: officeId,
      logicalId: selectedOffice.logicalId,
      selected_type: eyeExam,
      slot_type: doctorCache?.offersVEH ? "VEH" : "Traditional",
      patient_type: patientType,
      doctorId: doctorCache?.id,
    });
  };

  const onNextMobile = () => {
    setShowSlotSection(true);
    setTimeout(() => {
      examTypeRef?.current?.scrollIntoView();
    }, 10);
    //isFormValidation(patientDetails);
    isFormValidation({
      eyeExam: eyeExam,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: selectedSlot,
      patientDetails: patientDetails,
    });
    setDataPush(false);
  };

  const onSelectionExamType = (type: string, value: ExamType) => {
    setEyeExam(value);
    /* some delay when popup close */
    setTimeout(() => {
      patientTypeRef?.current?.scrollIntoView();
      trackEvent("step-3-selected-eyewear-type", {
        location: officeId,
        logicalId: selectedOffice.logicalId,
        selected_type: value,
        slot_type: selectedDoctor?.offersVEH ? "VEH" : "Traditional",
        patient_type: patientType,
        doctorId: selectedDoctor?.id,
      });
    }, 10);
    //isFormValidation(patientDetails);
    isFormValidation({
      eyeExam: value,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: selectedSlot,
      patientDetails: patientDetails,
    });
    setDataPush(false);
  };

  const onSelectionPatientType = (type: string, value: PatientReturnStatus) => {
    setPatientType(value);
    isFormValidation({
      eyeExam: eyeExam,
      patientType: value,
      selectedDoctor: selectedDoctor,
      selectedSlot: selectedSlot,
      patientDetails: patientDetails,
    });
    setTimeout(() => {
      patientDetailsRef?.current?.scrollIntoView();
      trackEvent("step-4-selected-patient-type", {
        location: officeId,
        logicalId: selectedOffice.logicalId,
        selected_type: eyeExam,
        slot_type: selectedDoctor?.offersVEH ? "VEH" : "Traditional",
        patient_type: value,
        doctorId: selectedDoctor?.id,
      });
    }, 10);
  };

  const onSelectNextAvail = (date: string) => {
    if (weekCalendar.length > 0 && weekCalendar.indexOf(date) > -1) {
      setSelectedDate(date);
    } else {
      const params = new URLSearchParams(history.location.search);
      params.set("date", date);
      setExecuteOnce(false);
      setSearchDate(date);
      setSelectedDate(date);
      history.replace({ search: params.toString() });
      setTimeslotsExecution();
    }
  };

  const filteredDoctorSlots = (
    condition: (availability: DoctorAvailability) => boolean
  ) => {
    return compact(
      newSortedDoctorIds.map((doctorId) => {
        const availability = doctorAvailbilities[doctorId];
        const doctor = doctors.find((doctor) => doctor.id === doctorId);
        return (
          doctor &&
          condition(availability) && (
            <ConnectedDoctorSlots
              key={`doctor-cards-${doctor.id}`}
              officeId={officeId}
              doctor={doctor}
              selectedSlot={selectedSlot}
              onSelection={onSelectionTimeSlot}
              onNextMobile={onNextMobile}
              onSelectNextAvail={onSelectNextAvail}
              forDate={selectedDateTemp}
              examType={examType}
              patientReturnStatus={patientReturnStatus}
              office={selectedOffice}
              version={2}
            />
          )
        );
      })
    );
  };

  const isNearByOfficesLoading = useSelector((state: RootState) =>
    selectNearbyOfficeLoadingState(state)
  );

  const doctorsWithAvailability = filteredDoctorSlots(
    (availability) => availability !== null
  );
  const doctorsWithoutAvailability = filteredDoctorSlots(
    (availability) => availability === null
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isFormValidation = (data: any) => {
    if (
      selectedOffice &&
      data.patientType &&
      data.selectedSlot &&
      data.selectedDoctor &&
      data.eyeExam &&
      patientDetailsValid(data.patientDetails)
    ) {
      setNextButton(false);
      setApptData({
        office: selectedOffice,
        doctor: data.selectedDoctor,
        timeSlot: data.selectedSlot,
        patientType: data.patientType,
        eyeExam: data.eyeExam,
        patientDetails: data.patientDetails,
        lastRequestUrl: searchDate,
      });
    } else {
      if (!nextButton) setNextButton(true);
    }
  };

  const updatePatient = (fieldValue: any) => {
    const pDetails = cloneDeep(patientDetails);
    if (fieldValue?.field === "firstName") {
      pDetails.firstName = fieldValue?.value;
    }
    if (fieldValue?.field === "lastName") {
      pDetails.lastName = fieldValue?.value;
    }
    if (fieldValue?.field === "phoneNumber") {
      pDetails.phoneNumber = fieldValue?.value;
    }
    if (fieldValue?.field === "email") {
      pDetails.email = fieldValue?.value;
    }
    if (fieldValue?.field === "dateOfBirth") {
      pDetails.dateOfBirth = fieldValue?.value;
    }
    if (fieldValue?.field === "smsOptInNotices") {
      pDetails.smsOptInNotices = fieldValue?.value;
    }
    if (fieldValue?.field === "smsOptInPromos") {
      pDetails.smsOptInPromos = fieldValue?.value;
    }
    setPatientDetails(pDetails);
    isFormValidation({
      eyeExam: eyeExam,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: selectedSlot,
      patientDetails: pDetails,
    });
  };

  React.useEffect(() => {
    if (!dataPush) {
      if (
        selectedSlot &&
        selectedDoctor &&
        eyeExam &&
        patientType &&
        patientDetailsValid(patientDetails)
      ) {
        setNextButton(false);
        setDataPush(true);
        setApptData({
          office: selectedOffice,
          doctor: selectedDoctor,
          timeSlot: selectedSlot,
          patientType: patientType,
          eyeExam: eyeExam,
          patientDetails: patientDetails,
          lastRequestUrl: searchDate,
        });
      } else {
        setNextButton(true);
        setDataPush(false);
      }
    }
  }, [
    eyeExam,
    selectedOffice,
    patientDetails,
    patientDetailsValid,
    patientType,
    selectedDoctor,
    selectedSlot,
    dispatch,
    searchDate,
    setApptData,
    dataPush,
  ]);

  const moveToNext = () => {
    //isFormValidation(patientDetails);
    isFormValidation({
      eyeExam: eyeExam,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: selectedSlot,
      patientDetails: patientDetails,
    });
    if (!nextButton) setShowReview(true);
  };

  React.useEffect(() => {
    setTimeout(() => {
      if (isEditForm) {
        const appData = cloneDeep(appoinmentData);
        // Removed `selectedOffice = appData["office"]` — that was a
        // direct prop mutation which doesn't trigger a re-render and causes
        // stale closure bugs. The parent component owns selectedOffice; if it
        // needs to change it should be lifted to the parent via a callback.
        setSelectedDoctor(appData["doctor"]);
        setSelectedSlot(appData["timeSlot"]);
        setEyeExam(appData["eyeExam"]);
        setPatientType(appData["patientType"]);
        setPatientDetails(appData["patientDetails"]);
      }
      if (isEditForm && editSection) {
        if (editSection === "timeSlot") {
          setShowSlotSection(false);
          setSelectedDoctor(undefined);
          setSelectedSlot(undefined);
          /*setTimeout(() => {
            WeekTimeSlotsRef?.current?.scrollIntoView();
          }, 10); */
        }
        if (editSection === "patientDetails") {
          setShowSlotSection(true);
          requestAnimationFrame(() => {
            patientDetailsRef?.current?.scrollIntoView();
          });
        }
      } else if (editSectionModal) {
        if (editSectionModal === "timeSlot") {
          setShowSlotSection(false);
          setSelectedDoctor(undefined);
          setSelectedSlot(undefined);
          /*setTimeout(() => {
            WeekTimeSlotsRef?.current?.scrollIntoView();
          }, 10); */
        }
        if (editSectionModal === "patientDetails") {
          setShowSlotSection(true);
          requestAnimationFrame(() => {
            patientDetailsRef?.current?.scrollIntoView();
          });
        }
      }
    }, 10);
  }, [setSelectedDoctor, setSelectedSlot, editSectionModal]);

  const today = dayjs().format(API_DATE_FORMAT);
  const restrictDate = 7 * (1 + selectedOffice.timeSlotWeeks);
  const restrictedDay = dayjs(today)
    .add(restrictDate, "day")
    .format(API_DATE_FORMAT);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let weekCalendar: any[] = [];
  ["0", "1", "2", "3", "4"].map((i) =>
    weekCalendar.push(
      dayjs(searchDate).add(parseInt(i), "day").format(API_DATE_FORMAT)
    )
  );
  const calendarIndex = weekCalendar.indexOf(restrictedDay);
  if (calendarIndex > -1) {
    if (calendarIndex === 0) weekCalendar = [weekCalendar[calendarIndex]];
    else weekCalendar = weekCalendar.slice(0, calendarIndex);
  }
  const trackBrowseDatesEvent = () => {
    setExecuteOnce(false);
    setDateFirstExecuteOnce(false);
    setSelectedDate(undefined);
    setTimeslotsExecution();
  };

  const onSelectionfirstSlot = (slot: any) => {
    if (slot && dayjs(slot.date) > dayjs().add(6, "day")) {
      onSelectDate(slot.date);
    }
    onSelectionTimeSlot("firstAvail", slot);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onSelectDate = (date: string) => {
    userSelectedDateRef.current = true;
    if (weekCalendar.length > 0 && weekCalendar.indexOf(date) > -1) {
      setSelectedDate(date);
      setExecuteOnce(false);
    } else {
      const params = new URLSearchParams(history.location.search);
      params.set("date", date);
      setExecuteOnce(false);
      setSelectedDate(date);
      history.replace({ search: params.toString() });
    }
  };

  const slotsByDoctor = useSelector((state: RootState) =>
    selectUpcomingTimeslotsForOfficeByDate(state, officeId)
  );

  React.useEffect(() => {
    if (isSlotLoaded && !dateFirstexecuteOnce && !isEditForm) {
      if (userSelectedDateRef.current) {
        setDateFirstExecuteOnce(true);
        return;
      }
      let dayStart = false;
      for (const weekDay in weekCalendar) {
        if (dayStart) break;
        if (typeof newDateArr[weekCalendar[weekDay]] !== "undefined") {
          dayStart = true;
          onSelectDate(weekCalendar[weekDay]);
          setDateFirstExecuteOnce(true);
          break;
        }
      }
    }
  }, [
    newDateArr,
    isSlotLoaded,
    isEditForm,
    slotsByDoctor,
    weekCalendar,
    onSelectDate,
    dateFirstexecuteOnce,
  ]);

  React.useEffect(() => {
    if (weekCalendar.length > 0 && !executeOnce) {
      if (
        dayjs(selectedDateTemp).format(API_DATE_FORMAT) ===
        dayjs().format(API_DATE_FORMAT)
      ) {
        setPrevWeek("");
      } else {
        const dateStr = dayjs(weekCalendar[0])
          .subtract(4, "day")
          .format(API_DATE_FORMAT);
        const prevDate = dayjs(weekCalendar[0])
          .subtract(5, "day")
          .format(API_DATE_FORMAT);
        if (!dayjs().isBefore(dateStr)) {
          const params = new URLSearchParams(history.location.search);
          params.set("date", dayjs().format(API_DATE_FORMAT));
          history.replace({ search: params.toString() });
        } else {
           //setPrevWeek("start?date=" + prevDate);
          setPrevWeek(updateQueryParam("date", prevDate));
        }
      }
      if (
        weekCalendar.length === 5 &&
        weekCalendar[4] !== restrictedDay &&
        !dayjs(restrictedDay).isSame(dayjs(weekCalendar[4]).add(1, "day")) &&
        dayjs(weekCalendar[4]).isBefore(restrictedDay)
      ) {
        setNextWeek(
          updateQueryParam(
            "date",
            dayjs(weekCalendar[4]).add(1, "day").format(API_DATE_FORMAT)
          )
        );
      } else {
        setNextWeek("");
      }
      setExecuteOnce(true);
    }
  }, [
    executeOnce,
    history,
    restrictedDay,
    selectedDateTemp,
    selectedOffice.timeSlotWeeks,
    weekCalendar,
  ]);

  React.useEffect(() => {
    if (screenSize <= 992) {
      if (
        !isEmpty(slotMetaData) &&
        slotMetaData[selectedDateTemp] &&
        totalSlotCount > 0 &&
        !isEmpty(slotMetaData[selectedDateTemp])
      ) {
        const searchDateSlots = slotMetaData[selectedDateTemp];
        trackEvent("slotsLoaded", {
          totalSlotCount: searchDateSlots.total_slots,
          hiddenSlotCount: searchDateSlots.hide_slots,
          visibleSlotCount: searchDateSlots.visible_slots,
          rslBypass: true,
          location: selectedOffice.id,
        });
      }

      if (isSlotLoaded && totalSlotCount > 0 && isEmpty(slotMetaData)) {
        trackEvent("slotsLoaded", {
          totalSlotCount: totalSlotCount,
          hiddenSlotCount: 0,
          visibleSlotCount: totalSlotCount,
          rslBypass: false,
          location: selectedOffice.id,
        });
      }
    }
  }, [
    trackEvent,
    slotMetaData,
    selectedDateTemp,
    screenSize,
    isSlotLoaded,
    searchDate,
    totalSlotCount,
    selectedOffice,
  ]);
  const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked(!checked);
  };

  const onRestrictVEHSelection = () => {
    setRestrictVehTerms(true);
  };

  const calendarDays = weekCalendar.map((day) => (
    <div
      key={day}
      className={
        selectedDateTemp === day
          ? cx(styles.dayContainer, styles.daySelected)
          : styles.dayContainer
      }
      onClick={() => onSelectDate(day)}
      aria-hidden="true"
    >
      <div className={styles.dayWords}>{dayjs(day).format("ddd")}</div>
      <div className={styles.monthYear}>
        {dayjs(day).format("MMM")} {dayjs(day).format("D")}
      </div>
    </div>
  ));

  return (
    <div className={styles.mobileView}>
      <Modal
        className={styles.vehModal}
        aria={ariaRestrict}
        isOpen={restrictVehTerms}
        closeOnOverlayClick={false}
        hideClose={true}
      >
        <div className={styles.restrictVEHContent}>
          Please note, this doctor conducts remote in-office exams. At this time
          remote exams are only available for existing MyEyeDr. patients.
        </div>
        <div>
          <Button
            text="I AM AN EXISTING PATIENT"
            size="large"
            onClick={() => {
              //console.log("Yes");
              onSelectionPatientType(
                "patientType",
                PatientReturnStatus.Returning
              );
              setRestrictVehTerms(false);
            }}
            className={styles.buttonRestrict}
          />
          <Button
            text="No, I’d like to choose a different doctor"
            size="large"
            role={ButtonRole.Ghost}
            onClick={() => {
              //console.log("No");
              setRestrictVehTerms(false);
              setVehDoctorTerms(false);
              setSelectedDoctor(undefined);
              setSelectedSlot(undefined);
              setVehSelectedSlot(undefined);
              setPatientType(undefined);
              setShowSlotSection(false);
              setChecked(false);
            }}
            className={styles.buttonRestrict}
          />
        </div>
      </Modal>
      <Modal
        className={styles.newvehModal}
        contentclassName={styles.conClass}
        aria={aria}
        isOpen={vehDoctorTerms}
        closeOnOverlayClick={false}
        hideClose={true}
      >
        <div className={styles.vehContent}>
          <div>
            <p className={styles.nvehheader}>
              <img
                className={styles.iconSmile}
                src={iconSmile}
                alt=""
                />{" "}Same great care, more flexible</p>
          </div>
          <div>
            <img
              className={styles.imgPatient}
              src={vehPatientImg}
              alt=""
              />
          </div>

          <div>
            <p className={styles.newP1}>
              <span>
                You’ll come into our office and get a full comprehensive eye exam with a licensed optometrist who will video call in.
              </span>
            </p>
          </div>

          <div className={styles.newL1}>
            <p>Some important things to note about this exam:</p>
          </div>

          <div className={styles.newL2}>
            <ul>
              {selectedOffice.restrictVEH && (
                <>
                  <li>
                    <div className={styles.listContainer}>
                      <div className={styles.listImg}>
                        <img
                          className={styles.iconBaby}
                          src={iconReturn}
                          alt=""
                        />
                      </div>
                      <div className={styles.listText}>
                        Patients must be existing MyEyeDr. patients, not new patients.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={styles.listContainer}>
                      <div className={styles.listImg}>
                        <img
                          className={styles.iconBaby}
                          src={iconBaby}
                          alt=""
                        />
                      </div>
                      <div className={styles.listText}>
                        {selectedOffice.ageRestrictVEH && ( <>Patients must be between 18-55 years old. </>)}
                        {!selectedOffice.ageRestrictVEH && ( <>Patients must be at least 10 years old. </>)}
                      </div>
                    </div>
                  </li>
                </>
              )}
              {!selectedOffice.restrictVEH && (
                <li>
                  <div className={styles.listContainer}>
                    <div className={styles.listImg}>
                      <img
                        className={styles.iconBaby}
                        src={iconBaby}
                        alt=""
                      />
                    </div>
                    <div className={styles.listText}>
                      {selectedOffice.ageRestrictVEH && ( <>Patients must be between 18-55 years old. </>)}
                      {!selectedOffice.ageRestrictVEH && ( <>Patients must be at least 10 years old. </>)}
                    </div>
                  </div>
                </li>
              )}


              <li>
                <div className={styles.listContainer}>
                  <div className={styles.listImg}>
                    <img
                      className={styles.iconBaby}
                      src={iconClip}
                      alt=""
                    />
                  </div>
                  <div className={styles.listText}>
                    <b>We recommend retinal imaging to all our patients.</b> Retinal imaging lets your doctor see the inside and back of your eye to catch issues early, and it’s required for this exam. The fee for retinal imaging is $44.
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <Button
              text="Accept & Schedule"
              size="large"
              onClick={() => {
                setVehDoctorTerms(false);
                //setShowSlotSection(true);
                setSelectedSlot(vehSelectedSlot);
                setPatientType(undefined);
                setChecked(false);
                dispatch(
                  updateSelectedAppointment({
                    officeId,
                    officeUid,
                    ...vehSelectedSlot,
                  })
                );
              }}
              className={styles.buttonAcc}
            />
          </div>
          <div className={styles.btnGoContainer}>
            <div
              onClick={() => {
                setVehDoctorTerms(false);
                setSelectedDoctor(undefined);
                setSelectedSlot(undefined);
                setVehSelectedSlot(undefined);
                setShowSlotSection(false);
                setChecked(false);
              }}
              className={styles.buttonGo}>
              <img
                className={styles.iconBack}
                src={arrowLeft}
                alt="Go Back"
              />{" "}Go Back
            </div>
          </div>
        </div>
      </Modal>
      <div>
        <div className={cx(styles.customSteps, styles.customOfficeSteps)}>
          <img className={styles.officeIcon} src={circleCheck} alt="Check" />
          <h1>
            {isV3 ? "Selected Office" : "SELECTED OFFICE"}
            {isV3 && selectedOffice.supportsMedicaid && (
              <p className={styles.medicaidV3}>
                <span className={styles.mediTextV3}>
                  Medicaid <span className={styles.boldUnderline}>is</span>{" "}
                  accepted{" "}
                </span>
              </p>
            )}
            {isV3 && !selectedOffice.supportsMedicaid && (
              <p className={styles.medicaidV3}>
                <span className={styles.mediTextV3}>
                  Medicaid <span className={styles.boldUnderline}>
                  is not
                  </span>{" "}
                  accepted{" "}
                </span>
              </p>
            )}
            {!isV3 && selectedOffice.supportsMedicaid && (
              <p className={styles.medicaid}>
                <img src={handbagIcon} alt="" className={styles.icon} />
                <span className={styles.mediText}>
                  Medicaid <span className={styles.boldUnderline}>is</span>{" "}
                  accepted{" "}
                </span>
              </p>
            )}
            {!isV3 && !selectedOffice.supportsMedicaid && (
              <p className={styles.medicaid}>
                <img src={handbagIcon} alt="" className={styles.icon} />
                <span className={styles.mediText}>
                  Medicaid <span className={styles.boldUnderline}>
                  is not
                  </span>{" "}
                  accepted{" "}
                </span>
              </p>
            )}
          </h1>
          <div
            onClick={() => {
              externalRedirect(paths.LOCATIONS_PAGE_SEARCH_URL);
              setShowSlotSection(false);
            }}
            aria-hidden="true"
          >
            Change
          </div>
        </div>

        <TrustBuildCard />
        <div
          className={
            !showSlotSection ? styles.hideTimeSection : styles.showTimeSection
          }
        >
          <div className={cx(styles.customSteps, styles.doctorSteps)}>
            <img src={circleCheck} alt="Check" />
            {isV3 ? <h1>Selected Doctor and Time</h1> : <h1>SELECTED DOCTOR AND TIME</h1>}
            <div onClick={() => setShowSlotSection(false)} aria-hidden="true">
              Change
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          showSlotSection ? styles.hideTimeSection : styles.showTimeSection
        }
      >
        <NearbyOffice
          nearbyOffices={nearbyOffices}
          availabilitySlots={availabilitySlots}
          patientReturnStatus={patientReturnStatus}
          examType={examType}
          loading={isNearByOfficesLoading}
          version={2}
          isMobile={true}
          newDesign={newDesign}
          screenSize={screenSize}
          useClassicStartLayout={false}
        />
        <div className={styles.dateContainer}>
          <h1 className={styles.headline}> {isV3 ? "Select doctor and time slot" : "SELECT DOCTOR AND TIME SLOT"}</h1>
          <div className={styles.weekContainer}>
            <div className={cx(styles.arrow, styles.arrowLeft)}>
              <NavigationButton
                url={prevWeek}
                disabled={prevWeek === ""}
                direction="left"
                onClick={trackBrowseDatesEvent}
              />
            </div>
            {isV3 ? (
              <div className={styles.daysViewport}>
                <div className={styles.daysRow}>{calendarDays}</div>
              </div>
            ) : (
              calendarDays
            )}
            <div className={cx(styles.arrow, styles.arrowRight)}>
              <NavigationButton
                url={nextWeek}
                disabled={nextWeek === ""}
                direction="right"
                onClick={trackBrowseDatesEvent}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.officeSectionCustom}>
        <div
          className={
            showSlotSection ? styles.hideTimeSection : styles.showTimeSection
          }
        >
          {newDesign && showFeatureOffice && featureOffice && (
            <FeatureOffice featureOffice={featureOffice} isMobile={true} />
          )}
          {firstAvail && firstAvail === "true" && firstSlot && (
            <FirstAvailSlot onSelection={onSelectionfirstSlot} slot={firstSlot} />
          )}
          {doctors.length > 0 ? (
            doctorsWithAvailability
          ) : (
            <div className={styles.noAvailableDoctors}>
              Sorry there are no available doctors at this office
            </div>
          )}
          <div className={styles.borderDivider}></div>
          <WaitlistV2 office={selectedOffice} />
          <div className={styles.borderDivider}></div>
          {doctorsWithoutAvailability.length > 0 && (
            <DoctorAccordion title="Doctors with limited availability">
              {doctorsWithoutAvailability}
            </DoctorAccordion>
          )}
        </div>
        <div
          className={
            showSlotSection ? styles.showTimeSection : styles.hideTimeSection
          }
        >
          <div ref={examTypeRef}>
            <AppointmentExamDetails
              office={selectedOffice}
              eyeExam={eyeExam}
              onSelection={onSelectionExamType}
              isMobileView={isMobileView}
            />
          </div>
          <div className={styles.borderDividerSection}></div>
          <div ref={patientTypeRef}>
            <AppointmentSelectReturnStatus
              office={selectedOffice}
              doctor={selectedDoctor}
              patientType={patientType}
              onSelection={onSelectionPatientType}
              onRestrictVEHSelection={onRestrictVEHSelection}
            />
          </div>
          <div className={styles.borderDividerSection}></div>
          <div ref={patientDetailsRef}>
            <AppointmentAccountSetup
              office={selectedOffice}
              doctor={selectedDoctor}
              patient={patientDetails}
              updatePatient={updatePatient}
              isMobileView={isMobileView}
            >
              <div className={styles.buttonWrapper}>
                <div className={styles.container}>
                  <div
                    className={cx(
                      [styles.tooltipContainer, styles.tooltipPositionTop],
                      {
                        [styles.tooltipVisible]: nextButton,
                      }
                    )}
                  >
                    <div className={styles.contentContainer}>
                      <div className={styles.content}>
                        {selectedDoctor && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Time Slot selected{" "}
                          </div>
                        )}
                        {!selectedDoctor && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Time Slot not selected
                          </div>
                        )}
                        {eyeExam && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Eye Exam selected{" "}
                          </div>
                        )}
                        {!eyeExam && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Eye Exam not selected
                          </div>
                        )}
                        {patientType && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Patient Type selected{" "}
                          </div>
                        )}
                        {!patientType && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Patient Type not selected
                          </div>
                        )}
                        {patientDetailsValid(patientDetails) && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Patient Details updated
                          </div>
                        )}
                        {!patientDetailsValid(patientDetails) && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Patient Details not updated
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button
                      className={styles.footerNextBtnCustomMobile}
                      text="Review Details"
                      onClick={moveToNext}
                      role={ButtonRole.Standard}
                      size={"large"}
                      disabled={nextButton}
                    />
                  </div>
                </div>
              </div>
            </AppointmentAccountSetup>
          </div>
        </div>
        <div className={styles.footer}>
          <section className={cx(styles.footerSection, styles.footerLeft)}>
            <div className={styles.footerHeadingWithTooltip}>
              <h3 className={styles.footerHeading}>
                Other eyecare/vision needs?
              </h3>
              <InfoTooltip>
                <p>
                  Please call our office to schedule appointments for follow-ups
                  or urgent concerns.
                </p>
                <p>
                  Urgent concerns may include any kind of eye infection or
                  injury that impairs vision. Some examples are seeing floaters
                  or flashing lights.
                </p>
              </InfoTooltip>
            </div>
            <p className={styles.footerParagraph}>
              If you are experiencing an eyecare/vision needs outside of your exam, please call the office at{" "}
              <a
                href={toTel(formattedPhone)}
                className={styles.footerPhoneLink}
              >
                {formattedPhone}
              </a> to schedule an appointment.
            </p>
          </section>
          <hr className={styles.footerDivider} />
          <section className={cx(styles.footerSection, styles.footerRight)}>
            <h3 className={styles.footerHeading}>
              Need new glasses or contacts?
            </h3>
            <p className={styles.footerLinkContainer}>
              <a
                href={`${MYEYEDR_WEBSITE_URL}/eye-wear/shop-glasses`}
                target="_blank"
                rel="noreferrer"
                className={styles.footerLink}
              >
                Browse Glasses
              </a>
            </p>
            <p className={styles.footerLinkContainer}>
              {/* Safe access to orderContactUrl global */}
              <a
                href={getSafeOrderContactUrl()}
                target="_blank"
                rel="noreferrer"
                className={styles.footerLink}
              >
                Order Contacts
              </a>
            </p>
          </section>
          {showSlotSection && (
            <>
              <hr className={styles.footerDivider} />
              <section className={styles.smsFooter}>
                <p className={styles.smsHelp}>
                  * When scheduling an appointment on MyEyeDr.’s website, you are subscribed to receive email messages regarding your appointment and treatment as well as discounts and promotions. You can opt out of email messages at any time through the <i>Manage Email Preferences</i> link in any email or by contacting us at {" "}
                  <a href="mailto:PatientRelations@myeyedr.com">
                    PatientRelations@myeyedr.com
                  </a>.
                </p>
                <p className={styles.smsHelp}>
                  * Message frequency varies. Message and data rates may apply.
                  At any time you can text HELP for help or text STOP to stop
                  notifications.{" "}
                  <a
                    href="https://www.myeyedr.com/sms-terms-service"
                    target="_blank"
                    rel="noreferrer"
                  >
                    SMS Terms of Service
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.myeyedr.com/privacy-policy-practices"
                    target="_blank"
                    rel="noreferrer"
                  >
                    MyEyeDr. Privacy Policy
                  </a>
                </p>

                <div className={styles.agreeText}>
                  * I agree that you can contact me by text at the mobile number
                  provided. By agreeing I consent to receiving texts about
                  promotional offers related to eyewear and eyecare offers by
                  any type of dialing equipment, automated technology, or other
                  messaging system to send the communications. I understand
                  message frequency varies and that data and message rates may
                  apply.{" "}
                  <u>
                    I understand that I am not required to agree to such
                    messaging, and it is not a condition for the purchase of any
                    goods or services.
                  </u>
                  <p>* For more information about offers, discounts, and promotions - including Terms & Conditions - visit our{" "} 
                    <a href="https://www.myeyedr.com/offers" target="blank">Offers page.</a>
                  </p>
                </div>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
